module.exports = __webpack_public_path__ + "img/prev-step.d3f748e2.svg";